<template>
  <div>
    <SampleSearchForm
      :listForm="searchList"
      @handlerSearch="onSearch"
    />
    <div class="cml-button-group">
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        v-hasPermission="'warehouse-sample-manage/sample-batch-verify'"
        @click="batchVerify"
        >批量审核</el-button
      >
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        @click="transferBtn(selectData)"
        v-hasPermission="'warehouse-sample-manage/sample-batch-verify'"
        >批量转办</el-button
      >
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">容量：{{ row.capacity }}{{row.unit}}</div>
          </div>
        </div>
      </template>

      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
        
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="examine(row)"
          v-hasPermission="'sample-manage/sample-verify-btn'"
          >审核</el-button
        >
        <el-button
          type="text"
          @click="transferBtn([row])"
          v-hasPermission="'sample-manage/sample-verify-btn'"
          >转办</el-button
        >
      </template>
    </CommonTable>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
    <!-- 转办 -->
    <TransferDialog ref="TransferDialogRef" url="orderApprovalTransfer" :transferList="transferList" @saveBtn="getList" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
import TransferDialog from '@/components/transferDialog'
export default {
  components: { CommonTable, SampleSearchForm, SampleOperationLogDialog, TransferDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          }
        ],
      },
      listForm: {status: 'PENDING'},
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      selectData: [],
      tableHeadTab: [
        {
          label: '产品信息',
          prop: 'id',
          slotColumn: true,
          slotName: 'idSlot',
          width: 200,
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '样品类型', prop: 'sampleTypeName', width: 80 },
        { label: '供应商', prop: 'supplierName' },
        { label: '申请人', prop: 'demandStaffName', width: 100 },
        { label: '需求品牌', prop: 'demandBrandName', width: 100 },
        { label: '用途', prop: 'purpose' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 100,
        },
      ],
      tableDataTab: {},
      listData: {},
      TransferDialog: [],
      transferList: []
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderCheckInfoOrderList(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectData = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // table选择框
    selectChange(arr) {
      this.selectData = arr;
    },
    // 审核
    examine(row) {
      row.checkStatus = '';
      const sampleData = [{
        supplierName: row.supplierName,
        list: [row]
      }];
      this.addBtn('bill', sampleData);
    },
    // 转办
    transferBtn(rows) {
      this.transferList = [...rows];
      this.$refs.TransferDialogRef.open()
    },
    batchVerify() {
      const sampleData = this.selectData.reduce((prev, cur) => {
        cur.checkStatus = '';
        prev.push({
          supplierName: cur.supplierName,
          list: [cur]
        });
        return prev;
      }, []);
      this.addBtn('bill', sampleData);
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>

<style lang="less" scoped>
</style>